import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Container, Typography, CircularProgress, Alert, Button, Card, CardContent } from '@mui/material';
import { authService } from '../services/auth';
import { errorMessage } from '../services/api';
import SiteFooter from '../components/SiteFooter';

/**
 * Landing for SMS links (/s/<code>). Signs the person in and opens their
 * group page. The page itself reveals nothing about the match.
 */
const ShortLink: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current || !code) return;
    ran.current = true;
    authService
      .verifyShortLink(code)
      .then(({ groupId }) => navigate(`/g/${groupId}`, { replace: true }))
      .catch((err) => {
        if (authService.isAuthenticated()) {
          navigate('/dashboard', { replace: true });
          return;
        }
        setError(errorMessage(err, 'This link is invalid or has expired.'));
      });
  }, [code, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="sm" sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <Card sx={{ width: '100%' }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            {!error ? (
              <>
                <CircularProgress size={36} color="secondary" sx={{ mb: 2 }} />
                <Typography variant="h6" sx={{ fontFamily: 'inherit' }}>Opening your Secret Santa</Typography>
              </>
            ) : (
              <>
                <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Text-message links work once. Sign in with your email instead.
                </Typography>
                <Button variant="contained" onClick={() => navigate('/')}>Sign in</Button>
              </>
            )}
          </CardContent>
        </Card>
      </Container>
      <SiteFooter />
    </Box>
  );
};

export default ShortLink;
